import { RFIconProps } from "../types";

export default function BookIcon(props: RFIconProps) {
	return (
		<svg
			width="19"
			height="17"
			viewBox="0 0 19 17"
			fill="none"
			{...props}
			className={props.className || "w-[24px] h-[24px]"}
		>
			<path
				d="M5.19178 15.9091H3.98879C3.19612 15.9091 2.4359 15.6026 1.8754 15.057C1.31489 14.5115 1 13.7715 1 13V1H6.6787C7.41202 1.02094 8.10709 1.32321 8.61237 1.84091C9.11766 2.35861 9.39218 3.04974 9.37609 3.76364V15.9091H5.19178Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M13.6275 15.9091H14.8305C15.6232 15.9091 16.3834 15.6026 16.9439 15.057C17.5044 14.5115 17.8193 13.7715 17.8193 13V1H12.1406C11.7721 1.00282 11.4077 1.07677 11.0687 1.21755C10.7298 1.35834 10.4228 1.56318 10.1657 1.8202C9.90858 2.07722 9.70639 2.38133 9.57084 2.71492C9.43528 3.04852 9.36905 3.40496 9.37598 3.76364V15.9091H13.6275Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}
